// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/** Archiver : la caisse d'archives fermee. Source `archive.svg`. */
export const IconArchive = createCustomIcon(
  'IconArchive',
  '0 0 239.01 221.61',
  <>
    <path
      fill="currentColor"
      d="M239.01,0v69.71l-17.38.08-.05,151.82H17.43s-.05-151.81-.05-151.81l-17.38-.15V0s239.01,0,239.01,0ZM196.66,69.71H42.35v126.94h154.3v-126.94Z"
    />
    <rect fill="currentColor" x="89.63" y="97.07" width="59.75" height="24.95" />
  </>,
);
